if (!customElements.get('hydros-cart-recommendation')) {
  customElements.define('hydros-cart-recommendation', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-growth-add]');
      this.variant = this.querySelector('[data-growth-variant]');
      this.error = this.querySelector('[data-growth-error]');
      this.errorText = this.querySelector('[data-growth-error-text]');
      this.handleAdd = () => this.add();
      this.handleChange = (event) => {
        // CartItems treats bubbling changes as line-quantity changes.
        event?.stopPropagation();
        const price = this.variant.selectedOptions?.[0]?.dataset.price;
        if (price) this.querySelector('[data-growth-price]').textContent = price;
      };
      this.button?.addEventListener('click', this.handleAdd);
      this.variant?.addEventListener('change', this.handleChange);
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleAdd);
      this.variant?.removeEventListener('change', this.handleChange);
    }
    async add() {
      if (this.pending || !this.button || this.button.disabled) return;
      const id = Number(this.variant?.value);
      if (!Number.isSafeInteger(id) || id <= 0) return;
      this.pending = true;
      this.button.disabled = true;
      this.variant.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      const label = this.querySelector('[data-growth-label]');
      const originalLabel = label.textContent;
      label.textContent = this.dataset.pendingLabel;
      this.error.hidden = true;
      const drawer = this.closest('cart-drawer');
      const payload = { items: [{ id, quantity: 1 }], sections_url: window.location.pathname };
      if (drawer) payload.sections = drawer.getSectionsToRender().map(section => section.id);
      let added = false;
      try {
        const response = await fetch(window.routes.cart_add_url, { ...fetchConfig(), body: JSON.stringify(payload) });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || this.dataset.errorMessage);
        added = true;
        if (window.location.pathname.replace(/\/$/, '') === window.routes.cart_url.replace(/\/$/, '')) {
          window.location.assign(window.routes.cart_url);
          return;
        }
        const sectionsReady = drawer && payload.sections.every(key => typeof data.sections?.[key] === 'string');
        if (sectionsReady) {
          drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          // Replacing an already open drawer invalidates its old focus trap.
          const container = drawer.querySelector('#CartDrawer');
          const close = drawer.querySelector('.drawer__close');
          if (container && close) trapFocus(container, close);
        } else window.location.assign(window.routes.cart_url);
      } catch (error) {
        if (added) { window.location.assign(window.routes.cart_url); return; }
        this.errorText.textContent = error instanceof TypeError || error instanceof SyntaxError ? this.dataset.errorMessage : error.message || this.dataset.errorMessage;
        this.error.hidden = false;
      } finally {
        this.pending = false;
        this.button.disabled = false;
        this.variant.disabled = false;
        this.button.removeAttribute('aria-busy');
        label.textContent = originalLabel;
      }
    }
  });
}
